import { render, staticRenderFns } from "./SelectRadioGroup.vue?vue&type=template&id=a51be870&scoped=true&lang=pug&"
import script from "./SelectRadioGroup.vue?vue&type=script&lang=js&"
export * from "./SelectRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./SelectRadioGroup.vue?vue&type=style&index=0&id=a51be870&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51be870",
  null
  
)

export default component.exports